import { UserApple } from './UserApple';
import { useQuery } from "@tanstack/react-query";
import { createFetchErrorMessage } from 'utils/api/Api';
import { UserScore } from './UserScore';
import { ErrorMessageBox } from 'bf-library';
import { getUser } from '../apiUser';

export const UserApplePage = ({ userId }) => {
    const { data: userInfo, isError, error } = useQuery({
        queryKey: ['user/info', userId],
        queryFn: getUser,
        refetchOnMount: 'always',
    });

    // if ( isLoading ) return <Loading />;
    if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;
    return (
        <div className='user_apple_page'>
            <div className="user_info_container">

                <div className="info_box apple_tree">
                    <div className="tree_wrap">
                        <UserApple userId={userId} />
                    </div>
                </div>

                <div className="info_box user_info_area">
                    <div className="cloud"><img src={`${process.env.PUBLIC_URL}/static/images/user/cloud.png`} alt="구름" /></div>
                    <UserScore score={userInfo?.data?.score} />
                </div>

            </div>
        </div>
    );
};